let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2l9Qq")).then(() => parcelRequire('jJyya'));